var _circle, _circle2, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    transform: "rotate(90 26 26)",
    fill: "#AAD267"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.777,
    cy: 27.5365,
    r: 15.4027,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.059,
    cy: 30.7238,
    rx: 1.06225,
    ry: 1.59338,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.557,
    cy: 30.7238,
    rx: 1.06225,
    ry: 1.59338,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4325 34.4414H24.918C24.918 35.5037 25.7147 36.3004 27.308 36.3004C28.8103 36.3004 29.344 35.1496 29.4325 34.4414Z",
    fill: "#F09387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4551 29.3195L13.3081 24.8843L11.5617 24.8844C11.0926 26.0885 11.2951 28.0458 11.4551 29.3195Z",
    fill: "#105ECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4955 25.5502H11.3771C12.869 18.6043 19.0446 13.3975 26.4363 13.3975C33.8281 13.3975 40.0037 18.6043 41.4955 25.5502Z",
    fill: "#105ECE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1463 25.5506L12.2654 21.7266C14.6223 15.0183 21.4133 10.6308 28.7503 11.5697C36.0874 12.5087 41.5546 18.4649 42.1463 25.5506Z",
    fill: "#F3EF87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98282 22.8094C9.02261 21.9082 11.1778 21.6427 12.2504 21.6225L42.0561 25.4369C40.5059 27.2213 8.93308 23.9359 8.98282 22.8094Z",
    fill: "#FF9E00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2335 29.6785L40.1143 25.3641L41.9205 25.2707C42.3682 25.7222 42.3157 28.3973 42.2335 29.6785Z",
    fill: "#105ECE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile2);
export default __webpack_public_path__ + "static/media/img_profile_2.4791cc3e694afab4f9626fc07992ceb5.svg";
export { ForwardRef as ReactComponent };